/* Service Worker Registration for PWA */

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register in production preview (skip during local dev's HMR webpack overlay churn)
  if (window.location.hostname === "localhost") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        // Auto-update on new version
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              // New version available — silently activate on next nav
              newWorker.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => { /* swallow silently — app still works without SW */ });

    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      // Don't auto-reload — let user navigate naturally
    });
  });
}
